import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DashboardOutlined,
  UserAddOutlined,
  ProductOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  BorderOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, theme, Avatar, Dropdown } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  const handleMenuClick = (e) => {
    if (e.key === 'signout') {
      // Handle logout logic here
    } else {
      navigate(e.key);
    }
  };

  const userMenu = (
    <Menu>
      {/* <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="signout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item> */}
    </Menu>
  );

  return (
    <Layout style={{ minHeight: '100vh', fontFamily: 'Poppins, sans-serif' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(isCollapsed) => setCollapsed(isCollapsed)}
        style={{
          background: 'linear-gradient(180deg, #004d40 0%, #00251a 100%)',
          boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
        }}
      >
        <div style={{ height: 64, margin: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <h1 style={{ color: '#fff', margin: 0, fontSize: '24px', fontWeight: 'bold', letterSpacing: '1px' }}>
            ACCI
          </h1>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['']}
          onClick={handleMenuClick}
          style={{ background: 'transparent', borderRight: 0 }}
        >
          <Menu.Item key="" icon={<DashboardOutlined className="fs-4" />}>
            Dashboard
          </Menu.Item>
          <Menu.SubMenu key="Users" icon={<UserOutlined className="fs-4" />} title="MEMBERS">
            <Menu.Item key="otherparticipations" icon={<UserOutlined className="fs-4" />}>
              MEMBER
            </Menu.Item>
            <Menu.Item key="rqlist" icon={<UserOutlined className="fs-4" />}>
              Archive List
            </Menu.Item>
            <Menu.Item key="visitor" icon={<UserOutlined className="fs-4" />}>
              Visitor
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Santha" icon={<OrderedListOutlined className="fs-4" />} title="Santha">
            <Menu.Item key="santhamaster" icon={<BorderOutlined className="fs-4" />}>
              Santha Master
            </Menu.Item>
            <Menu.Item key="santha" icon={<BorderOutlined className="fs-4" />}>
              Santha Form
            </Menu.Item>
            <Menu.Item key="santhalive" icon={<BorderOutlined className="fs-4" />}>
              Santha Live Form
            </Menu.Item>
            <Menu.Item key="donation" icon={<BorderOutlined className="fs-4" />}>
              Santha Donation Form
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Events" icon={<ProductOutlined className="fs-4" />} title="Events">
            <Menu.Item key="event" icon={<BorderOutlined className="fs-4" />}>
              Event Registration
            </Menu.Item>
            <Menu.Item key="transactions" icon={<BorderOutlined className="fs-4" />}>
              Transactions
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Expense" icon={<OrderedListOutlined className="fs-4" />} title="Expense">
            <Menu.Item key="expense-master" icon={<BorderOutlined className="fs-4" />}>
              Expense Master
            </Menu.Item>
            <Menu.Item key="expense-form" icon={<BorderOutlined className="fs-4" />}>
              Expense Form
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Attendance" icon={<OrderedListOutlined className="fs-4" />} title="Attendance">
            <Menu.Item key="attendance" icon={<LogoutOutlined className="fs-4" />}>
              Attendance
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.Item key="/" icon={<LogoutOutlined className="fs-4" />}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: '0 24px',
            background: colorBgContainer,
            fontFamily: 'Poppins, sans-serif',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            zIndex: 1,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '18px',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              background: '#f5f5f5',
            }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span style={{ fontWeight: 500, color: '#555' }}>Admin</span>
            <Dropdown overlay={userMenu} trigger={['click']}>
              <Avatar style={{ cursor: 'pointer', backgroundColor: '#004d40' }} icon={<UserOutlined />} />
            </Dropdown>
          </div>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;